import { prompt, type PromptDefinition } from './models';

export const BUILDING_OWNER_PROMPTS = [
    prompt(
        'Understand it',
        'What needs attention in this building this week?',
        'Which buildings need attention this week?'
    ),
    prompt(
        'Meet obligations',
        "Which compliance obligations need my attention as this building's owner?",
        'Which buildings have owner compliance obligations needing attention?'
    ),
    prompt(
        'Keep it running',
        'What major repairs or replacements are recommended for this building?',
        'Which buildings have major repair or replacement recommendations to review?'
    ),
    prompt(
        'Meet obligations',
        'Find ownership records for this building relating to…',
        'Find ownership records across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Manage risk',
        'Which insurance or warranty documents for this building need review?',
        'Which buildings have insurance or warranty documents needing owner review?'
    ),
    prompt(
        'Understand it',
        "What unresolved matters have been escalated to this building's owner?",
        'Which buildings have unresolved matters awaiting an owner decision?'
    ),
    prompt(
        'Keep it running',
        'What do contractor reports say about completed work in this building?',
        'Which buildings lack satisfactory evidence of completed contractor work?'
    ),
    prompt(
        'Meet obligations',
        'Find owner approval requests for this building concerning…',
        'Find owner approval requests across my buildings concerning…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        "What evidence supports the proposed spending in this building's maintenance plans?",
        'Which buildings have proposed maintenance spending without clear supporting evidence?'
    ),
    prompt(
        'Coordinate people',
        "Who is recorded as responsible for managing this building's obligations?",
        'Which buildings have unclear responsibility for managing owner obligations?'
    ),
    prompt(
        'Understand it',
        "What documents should I request to understand this building's current risks?",
        'Which buildings have evidence gaps that limit my understanding of ownership risks?'
    ),
    prompt(
        'Meet obligations',
        'Help me review an ownership decision for this building about…',
        'Help me prioritise ownership decisions across my buildings about…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
